import { render, staticRenderFns } from "./AllCategoryBox.vue?vue&type=template&id=94227ef4&scoped=true&"
import script from "./AllCategoryBox.vue?vue&type=script&lang=js&"
export * from "./AllCategoryBox.vue?vue&type=script&lang=js&"
import style0 from "./AllCategoryBox.vue?vue&type=style&index=0&id=94227ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94227ef4",
  null
  
)

export default component.exports